import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} WorkingTimesActivityEdit
 * @property {Id} userId - ID of user who inserted or last modified the edit
 * @property {String} lastModified - Timestamp when edit was inserted/last modified
 * @property {String} [comment] - User comment for the edit
 * @property {boolean} [isPreview] - Flag for an edit that has not (yet) been submitted to be saved
 */

export const workingTimesActivityEditPropType = PropTypes.shape({
    userId: idPropType.isRequired,
    lastModified: iso8601PropType.isRequired,
    comment: PropTypes.string,
    isPreview: PropTypes.bool
})
